import React from 'react';
import { useNavigate } from 'react-router-dom';
import { slidingSessionConfig } from '../api/config';

export default function Header() {
  const navigate = useNavigate();
  const userData = JSON.parse(localStorage.getItem('current_user') || '{}');
  const displayName = userData.name || userData.username || userData.email || 'Kullanıcı';
  const initials = displayName.slice(0, 2).toUpperCase();

  function handleLogout() {
    localStorage.removeItem(slidingSessionConfig.tokenKey);
    localStorage.removeItem(slidingSessionConfig.userKey);
    localStorage.removeItem('user');
    window.dispatchEvent(new CustomEvent('auth-expired'));
    navigate('/login', { replace: true });
  }

  const logoStyle = {
    background: 'rgba(255,255,255,0.95)',
    borderRadius: 6,
    padding: '3px 8px',
    display: 'flex',
    alignItems: 'center'
  };

  return (
    <nav className="navbar app-header px-3 px-md-4 w-100">
      <div className="d-flex align-items-center gap-3">
        <button
          className="btn btn-sm text-white d-md-none p-1"
          type="button"
          data-bs-toggle="offcanvas"
          data-bs-target="#yanMenu"
          aria-controls="yanMenu"
        >
          <i className="fas fa-bars fa-sm"></i>
        </button>
        <div style={logoStyle}>
          <img src="/inkatechlogo.png" alt="Inkatech" style={{ height: 26, width: 'auto' }} />
        </div>
        <span className="stat-chip d-none d-lg-inline-flex">
          <span className="live-dot"></span>
          Canlı İzleme
        </span>
      </div>

      <div className="d-flex align-items-center gap-3">
        <span className="text-white-50 d-none d-md-inline" style={{ fontSize: '.82rem' }}>{displayName}</span>
        <div
          style={{
            width: 34, height: 34, borderRadius: '50%',
            background: 'linear-gradient(135deg,#0ea5e9,#10b981)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: '.75rem', fontWeight: 700, color: '#fff',
            fontFamily: 'Plus Jakarta Sans, sans-serif', cursor: 'pointer',
            boxShadow: '0 0 0 2px rgba(14,165,233,.4)',
            flexShrink: 0
          }}
          onClick={handleLogout}
          title={`${displayName} — Çıkış Yap`}
        >
          {initials}
        </div>
        <div style={{ ...logoStyle, padding: '3px 6px' }} className="d-none d-sm-flex">
          <img src="/Elitechlogo.png" alt="Elitech" style={{ height: 24, width: 'auto' }} />
        </div>
      </div>
    </nav>
  );
}
